import { useTranslation } from 'react-i18next';
import { QueryKeys } from '@connect-x-app/shared-domain-models';
import { updateSystemMessages } from '@connect-x-app/web-data-access';
import { toastError, toastSuccess } from '@connect-x-app/web-ui';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export const useUpdateSystemMessages = () => {
  const queryClient = useQueryClient();

  const { t } = useTranslation();

  const { isPending, mutateAsync } = useMutation({
    mutationFn: updateSystemMessages,
    mutationKey: [QueryKeys.SYSTEM_MESSAGES],
    onError: () => toastError(t('TOAST_ERROR')),
    onSuccess: () => {
      toastSuccess(t('TOAST_SUCCESS'));
      return queryClient.invalidateQueries({ queryKey: [QueryKeys.SYSTEM_MESSAGES] });
    },
  });

  return { isPending, updateSystemMessages: mutateAsync };
};
